import React from "react";
import Hero from "../medical/Hero";
import heroVideo from "../../assets/sales-video.mp4";
import {
  SALES_HERO_SUBHEADING,
  SALES_HERO_INTRO,
  SALES_HERO_CREDIBILITY,
  SALES_HERO_BOTTOM_PARAGRAPH,
} from "../../data/salesHeroContent";

export default function SalesHero() {
  return (
    <Hero
      title="Sales & Vertriebs-Executive-Search"
      subheading={SALES_HERO_SUBHEADING}
      intro={SALES_HERO_INTRO}
      video={heroVideo}
      credibility={SALES_HERO_CREDIBILITY}
      bottomParagraph={SALES_HERO_BOTTOM_PARAGRAPH}
      statsAsFloatingCards
      useBrandBackground={false}
    />
  );
}

